import React from "react";
import { useSelector } from "react-redux";
import Landing from "../Containers/Landing/";
import NoPermission from "../Containers/NoPermission";

function useItemValidator() {
  const user = useSelector((state) => state.AuthReducer?.user);
  const permissions = useSelector(
    (state) => state.AuthReducer?.user?.role?.access_permissions,
  );
  const modifiedPerms = useSelector(
    (state) => state.AuthReducer?.user?.role?.permissions,
  );
  const locations = useSelector((state) => state.AuthReducer?.user?.location);
  const subList = useSelector((state) => state.AuthReducer?.subList);

  const activeLocation = useSelector(
    (state) => state.SlickCareProfilesReducer.activeLocation,
  );

  function filterByValue(array, string) {
    let data = null;

    if (array?.length > 0) {
      let tempResult = array.find((o) =>
        Object.keys(o).some((k) =>
          o[k]
            .toString()
            .toLowerCase()
            .includes(string.toString().toLowerCase()),
        ),
      );
      if (tempResult?.id) {
        data = tempResult?.item_name;
      }
    }
    return data;
  }

  function itemValidator(
    component, // component to render
    item_name, // item to check — string, or an array (pass if ANY is subscribed)
    desired_permissions, // desired permission
    sub_bool, // should check for subscription
    checking_bool,
  ) {
    let renderComponent = <></>;
    let canView = false;
    let permits = ["NO ACCESS", "READ", "DISPLAY", "WRITE", "ADMIN"];
    const itemNames = (
      Array.isArray(item_name) ? item_name : [item_name]
    ).filter(Boolean);
    const landingItem = itemNames[0];
    let sub_check_required = false;

    if (subList?.length > 0) {
      let found = subList.find((ele) => itemNames.includes(ele.item_name));
      if (found?.id) {
        sub_check_required = true;
      }
    }

    let permList =
      user?.is_master_admin === true ||
      user?.accounting_type === "administrator"
        ? permissions
        : user.permissions.map((ele) => {
            return {
              ...ele.item_details,
              permission: permits[ele.permission_id],
            };
          });

    // Check Permission — admin bypass, else WRITE (etc.) on ANY of the items.
    // Permissions is reachable from Employees or Users-only homes, so a manager
    // holding EMPLOYEES write still passes at a CareCulture home that only has Users.
    const isAdmin =
      user?.is_master_admin === true ||
      user?.accounting_type === "administrator";
    const permission_item =
      isAdmin ||
      itemNames.some((name) => {
        const currentItem = permList?.find((x) => x.item_name === name);
        const currentPerm = currentItem?.permission ?? "NO ACCESS";
        return (
          permits.indexOf(currentPerm) >= permits.indexOf(desired_permissions)
        );
      });

    // Check Subscription on the basis of permission
    if (permission_item === true) {
      // if (sub_check_required === true) {
      let subscriptionList = [];
      let subscriptionData = null;
      let currentLocation;

      if (locations?.length > 0) {
        currentLocation = locations?.find(
          (ele) => ele.id == activeLocation?.id,
        );

        if (currentLocation?.id) {
          subscriptionList =
            currentLocation?.subscription_package_details ?? [];
        }
      }

      // If user has permission , check for subscription
      if (subscriptionList?.item_name) {
        subscriptionData = subscriptionList.item_name.find(
          (ele) =>
            itemNames.includes(ele.item_name) &&
            ele?.id &&
            ele?.subscription_status !== false,
        );
      }

      if (subscriptionData) {
        renderComponent = component;
        canView = true;
      } else {
        renderComponent = <Landing item={landingItem} />;
        canView = false;
      }
      // } else {
      //   // if subscription check is not required
      //   renderComponent = component;
      //   canView = true;
      // }
    } else {
      // if no permission
      renderComponent = <NoPermission />;
      canView = false;
    }

    return checking_bool ? canView : renderComponent;
  }

  return itemValidator;
}

export default useItemValidator;
